import { ViewModel,View } from "binder"
import { MultiSelectorBaseViewModel } from "src/common/reusableComponents/multiSelectorBase/multiSelectorBase-viewModel";
import { ServerConnection } from "src/server/serverConnection";

export class warehouseLocationMultiSelectorViewModel extends MultiSelectorBaseViewModel<warehouseLocation>{
    
    constructor(parentViewModel: ViewModel,warehouseId:string) {
        super(parentViewModel);
        this.warehouseId = warehouseId;
    }
    
    
    private _warehouseId : string;public get warehouseId() : string { return this._warehouseId;} public set warehouseId(v : string) {
        this._warehouseId = v;
        this.refresh();
    }
    
    protected async loadData(): Promise<warehouseLocation[]> {
        if(this.warehouseId==null || this.warehouseId=='')
            return [];

        let result = await ServerConnection.callServer('/Complex/InventoryLocationManagementServices/GetWarehousePlaces',{
            WarehouseParty:this.warehouseId
        });    
        return result.WarehousePlaces.map(q=>{
            let r = new warehouseLocation(this);
            r.id=q.Id;
            r.title = q.Name;
            return r;
        }); 
    }
    
}

export class warehouseLocation extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
}